/* eslint-disable @ms/forbid-file-names */
import { useIsPillarsOrPillarsHeaderEnabled } from '@ms/yammer-features-app-navigation';
import { useSettingsTeachingBubbleProps } from '@ms/yammer-hooks/dist/roleBasedFREs';
import { SettingsTeachingBubbleForRoleBasedFRE } from '@ms/yammer-role-based-fre';
import React, { FC } from 'react';

interface Props {
  readonly id: string;
}

export const SettingsTeachingBubble: FC<Props> = ({ id }) => {
  // this is to avoid displaying two teaching bubbles if the pillar_headers experiment is not enabled
  const isPillarsHeaderExperimentEnabled = useIsPillarsOrPillarsHeaderEnabled();
  const settingsTeachingBubbleProps = useSettingsTeachingBubbleProps(`#${id}`);
  const settingsTeachingBubble =
    settingsTeachingBubbleProps.isExperimentEnabled && isPillarsHeaderExperimentEnabled ? (
      <SettingsTeachingBubbleForRoleBasedFRE {...settingsTeachingBubbleProps} />
    ) : null;

  return settingsTeachingBubble;
};
